// extracted by mini-css-extract-plugin
export default {"container":"vD8B"};